import axiosV2Instance from './axiosV2Instance';

export interface TypeOfWorkV2 {
  id: number;
  name: string;
  closed: boolean;
  section: string;
}

class TypesOfWorkV2Api {
  async getTypesOfWork(options?: { includeClosed?: boolean }): Promise<TypeOfWorkV2[]> {
    try {
      const params = new URLSearchParams();

      if (options?.includeClosed) {
        params.append('includeClosed', 'true');
      }

      const query = params.toString();
      const response = await axiosV2Instance.get<TypeOfWorkV2[]>(`/types-of-work${query ? `?${query}` : ''}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching v2 types of work:', error);
      throw error;
    }
  }

  async getTypeOfWork(typeId: number): Promise<TypeOfWorkV2> {
    try {
      const response = await axiosV2Instance.get<TypeOfWorkV2>(`/types-of-work/${typeId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching v2 type of work ${typeId}:`, error);
      throw error;
    }
  }
}

export const typesOfWorkV2Api = new TypesOfWorkV2Api();


